import React, {useState} from "react";
import PropTypes from "prop-types";
import ResultNoticeService from "services/ResultNoticeService";
import {makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import clsx from "clsx";
import Tr from "translations/Translations";
import UploadFile from "components/UploadFile";
import AttachmentResultNoticeRow from "./AttachmentResultNoticeRow";
import EditDescriptionPopup from "components/popup/EditDescriptionPopup";
import DownloadHistoryPopup from "components/popup/DownloadHistoryPopup";
import AddNoticeReferenceNumberPopup
    from "../../../../../../../../components/complex/documentsTables/swz/AddNoticeReferenceNumberPopup";

const useStyles = makeStyles(theme => ({
    table: {
        tableLayout: 'fixed',
        '& td, th': {
            overflow: 'hidden',
        }
    },
    buttonColumn: theme.components.table.buttonColumn,
    dateColumn: theme.components.table.dateTimeColumn
}))

function AttachmentResultNotice(
    {
        demandId,
        editable,
        resultNotice
    }) {
    const classes = useStyles();
    const [addWorking, setAddWorking] = useState(false);
    const [editDescriptionFile, setEditDescriptionFile] = useState(null);
    const [editNoticeReferenceNumberFile, setEditNoticeReferenceNumberFile] = useState(null);
    const [downloadHistory, setDownloadHistory] = useState(null);

    const handleSendFiles = (files) => {
        if (files.length) {
            setAddWorking(true);
            ResultNoticeService.addResultNoticeAttachments(demandId, files).finally(() => setAddWorking(false));
        }
    }


    return (<>
            <TableContainer>
                <Table className={clsx(classes.table)}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{Tr("name")}</TableCell>
                            <TableCell className={classes.buttonColumn}>{Tr("description")}</TableCell>
                            <TableCell className={classes.dateColumn}>{Tr("add_data")}</TableCell>
                            <TableCell className={classes.dateColumn}>{Tr("publish_data")}</TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!!resultNotice.attachments && resultNotice.attachments.map(attachment => (
                            <AttachmentResultNoticeRow
                                key={attachment.identity}
                                demandId={demandId}
                                resultNotice={resultNotice}
                                editable={editable}
                                attachment={attachment}
                                onEditDescriptionFile={setEditDescriptionFile}
                                onDownloadHistory={setDownloadHistory}
                                onEditNoticeReferenceNumberFile={setEditNoticeReferenceNumberFile}
                            />

                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {editable &&
                <UploadFile
                    working={addWorking}
                    onUploadPopupClosed={handleSendFiles}
                />
            }
            {!!editDescriptionFile &&
                <EditDescriptionPopup
                    editDescriptionFile={editDescriptionFile} service={ResultNoticeService}
                    onUpdated={() => setEditDescriptionFile(null)} onClose={() => setEditDescriptionFile(null)}/>
            }
            {downloadHistory &&
                <DownloadHistoryPopup downloadHistoryFile={downloadHistory} service={ResultNoticeService} onClose={() => setDownloadHistory(null)}/>
            }
            {!!editNoticeReferenceNumberFile && <AddNoticeReferenceNumberPopup
                editNoticeReferenceNumberFile={editNoticeReferenceNumberFile}
                onUpdated={() => setEditNoticeReferenceNumberFile(null)}
                onClose={() => setEditNoticeReferenceNumberFile(null)}
                service={ResultNoticeService}
            />}
        </>
    )
}

AttachmentResultNotice.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    editable: PropTypes.bool.isRequired,
    resultNotice: PropTypes.object.isRequired
}


export default AttachmentResultNotice;